export const GET_PROJECT_ROLES = "GET_PROJECT_ROLES";

export const GetRoles = () => {
    return { type: GET_PROJECT_ROLES };
};
